/**
 * @generated SignedSource<<ed676f2f57c69688ae44108cde0bafe5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReturnProfile_featuredDeal$data = {
  readonly partnerSplitPostRecoupment: number | null;
  readonly partnerSplitPreRecoupment: number | null;
  readonly streamsPerDay: number | null;
  readonly termLengthMonths: number | null;
  readonly totalAmountRaising: number | null;
  readonly " $fragmentType": "ReturnProfile_featuredDeal";
};
export type ReturnProfile_featuredDeal$key = {
  readonly " $data"?: ReturnProfile_featuredDeal$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReturnProfile_featuredDeal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReturnProfile_featuredDeal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "termLengthMonths",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "streamsPerDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalAmountRaising",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "partnerSplitPreRecoupment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "partnerSplitPostRecoupment",
      "storageKey": null
    }
  ],
  "type": "FeaturedDealNode",
  "abstractKey": null
};

(node as any).hash = "a56f8a9213658a8189b5c120dbae7bc6";

export default node;
